import { render, staticRenderFns } from "./ModalNoteAdd.vue?vue&type=template&id=0a8aecc5&"
import script from "./ModalNoteAdd.vue?vue&type=script&lang=js&"
export * from "./ModalNoteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports